export const DEFAULT_COLORS = {
  primary_color: "#ffffff",
  secondary_color: "#e6e6e6",
  tertiary_color: "#4c92ff",
};
